<template>
  <div class="about">
    <div v-if="!showOops">
    <div class="about-header">
      <div class="header-content">
        <p class="title">Asian Family Market</p>
        <p class="quote">“to help Asian families in Seattle by bring the best  of Asian fresh food and groceries under one roof. ”</p>
        <div class="author">
          <div class="dash"></div>
          <p class="owner">OWNER KEN TAN</p>
        </div>
      </div>
    </div>
      <div class="content">
        <div class="brand">
          <div class="brand-left">
            <img class="icon" src="../assets/img/weChatIcon.svg"/>
            <img class="icon" src="../assets/img/instagramIcon.svg"/>
            <img class="icon" src="../assets/img/facebookIcon.svg"/>
          </div>
          <div class="brand-right">
            <h2>BRAND STORY</h2>
            <p class="bio">Owner Ken Tan, and the young immigrant from China, opened his first store Asian Food Center in 2007 with a simple dream: to help Asian families in the Eastside Seattle by bringing the best of Asian fresh food and groceries under one roof.</p>

            <p class="bio">Family is in Chinese also means home “家” We want every customer that came in our store feel welcoming, also can find a piece of memory of their home taste by the food we bring in.</p>
          </div>
        </div>
        <div class="brand-footer">
          <p class="green">(425）643-8558</p>
          <p class="green">work</p>
          <div class="col">
            <p class="green">Asian Family Market</p>
            <p class="green">(known as AFM)</p>
          </div>
        </div>
      </div>
      <div class="about-foot">
        <p class="about-head">LOCATION</p>
        <div class="location">
          <p class="about-cont">1. Bellevue AFM 14515 NE 20th St, Bellevue WA 98007</p>
          <p class="about-cont">2. Seattle AFM 13200 Aurora Ave N, Seattle WA 98133 </p>
          <p class="about-cont">3. Oregon AFC 3849 SW 117th Ave, Beaverton WA 97005
        </p>
        </div>
      </div>
      <div class="about-foot">
        <p class="about-head">STRATEGY</p>
        <div class="location">
          <p class="about-cont">Offer Premium Asian Grocery, Offer newest imported Asian Food; unique, fresh, organic produce; High quality meat with specialty cutting, fresh live seafood. Grab to go prepared food.  	</p>
        </div>
      </div>
        <img src="../assets/img/afmAboutImg.png" class="afm-img"/>
    <div class="get-started">
      <p class="hiw-title">{{$t('orderNow')}}</p>
      <div class="zip-button-container" :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}">
        <input
          type="text"
          :placeholder="zipcodeRequiredWarning ? $t('enter_zipcode_star') : $t('enter_zipcode')"
          v-model="zipcode"
          class="landing-subscribe-field"
          :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}"
          @keyup.enter="enterZip($event)"
        />
        <div @click="enterZip($event)" class="landing-icon-container">
          <font-awesome-icon icon="paper-plane" :style="{ color: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a', fontSize: '28px' }"/>
        </div>
      </div>
    </div>
  </div>
      <div class="oops-page-container" v-if="showOops">
    <img style="margin-bottom: 50px" class="oops-img" src="../assets/img/oops_zipcode.png"/>
    <p class="type1">{{$t('oops')}}……</p>
    <p style="margin-bottom: 20px" class="type1">{{ $t('your_location_is') }}</p>
    <p style="margin-bottom: 20px" class="type2">{{ $t('be_the_first') }}</p>
    <p style="margin-bottom: 20px" class="type3">{{ $t('you_also_get') }}</p>
     <div class="subscribe-button-container">
      <input
        type="text"
        :placeholder="$t('enter_email')"
        v-model="subscribeEmail"
        class="landing-subscribe-field"
      />
      <div v-if="subscribeEmailStatus === 'default'" @click="enterEmail($event)" class="landing-icon-container">
        <i class="fa fa-envelope-o" aria-hidden="true" :style="{ color: '#7cc26a', fontSize: '26px' }"></i>
      </div>
      <div v-if="subscribeEmailStatus === 'success'" class="landing-icon-container">
        <i class="fa fa-check" aria-hidden="true" :style="{ color: '#7cc26a', fontSize: '26px' }"></i>
      </div> <div v-if="subscribeEmailStatus === 'error'" class="landing-icon-container">
        <i class="fa fa-times" aria-hidden="true" :style="{ color: '#FA6400', fontSize: '26px' }"></i>
      </div>
    </div>
    <div style="width: 300px; display: flex; justify-content: center">
    <p style="margin-bottom: 50px; margin-top: 20px; margin-right: 10px; text-decoration: underline; cursor: pointer;" class="type3" @click="stillBrowse">{{ $t('still_browse') }}</p>
    <p style="margin-bottom: 50px; margin-top: 20px; text-decoration: underline; cursor: pointer; text-decoration-skip-ink: none;" class="type3" @click="tryAgain">{{$t('tryAgain')}}</p>
    </div>
  </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: "careers",
  data(){
    return {
      zipcodeRequiredWarning: false,
      zipcode: '',
      showOops: false,
      subscribeEmailStatus: 'default',
      subscribeEmail: '',
    }
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusHome', 'validateRadiusPurchase', 'toggleModal', 'resetHomeWithinRadius', 'resetHomeRadiusChecked', 'updateWarehouseLocation' ]),
    resetPage() {
      this.zipcodeRequiredWarning = false;
      this.zipcode = '';
      this.showOops = false;

   },
    enterZip(e) {
      e.preventDefault();
      if (!this.zipcode) {
        this.zipcodeRequiredWarning = true;
        return;
      }
      this.$store.dispatch('navbar/validateDeliveryRadius', this.zipcode);
      this.resetHomeWithinRadius();
   },
   stillBrowse() {
      this.$store.dispatch('navbar/validateDeliveryRadius', '98007');
      this.resetHomeWithinRadius();
   },
  validEmail: function (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
    tryAgain() {
     this.resetPage();
     document.documentElement.scrollTop = 0;
   },
    enterEmail(e) {
     if (this.subscribeEmail) {
         if (this.validEmail(this.subscribeEmail)) {
        this.postSubscribeEmail(this.subscribeEmail)
        .then(res => {
          this.subscribeEmailStatus = 'success';
        }).catch(err => {
          this.subscribeEmailStatus = 'error';
          setTimeout(() => {
            this.subscribeEmailStatus = 'default';
          }, 800);
        });
        } else {
          this.subscribeEmailStatus = 'error';
          setTimeout(() => {
            this.subscribeEmailStatus = 'default';
          }, 800);
        }
      }
   },
  },
  watch: {
    homeWithinRadius: function(newVal, oldVal) {
      if (newVal === false) {
        this.showOops = true;
        document.documentElement.scrollTop = 150;
      }
      if (newVal === true && this.$router.currentRoute.path === '/about-us') {
        this.$router.push('/home');
      }
    },
    $route(to, from) {
      this.resetPage();
    }
  },
  computed: mapState ({
    homeWithinRadius: state => state.navbar.homeWithinRadius
  }),
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/about.vue